







































































































































import VueOptions from '@utils/VueOptions'
import DebugOnly from '@components/DebugOnly'

isDev = process.env.NODE_ENV is 'development'

settings =
  name: 'OfferHeader'
  components: { DebugOnly }

  resources:
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'
      fetch: false
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'
      fetch: false

  vue:
    props: ['offer', 'offerProgress', 'actions']

    data: ->
      showMoreOfferActions: false

    computed:
      devMode: -> isDev

      audienceListingId: -> @ctxAudienceListing(@offer).id
      vendorListingId: -> @ctxVendorListing(@offer).id
      listing: -> @audience_listing || @vendor_listing
      activationPlan: -> @offer.activation_plan
      shippingArea: -> @ctxShippingArea @offer

      lineItem: -> @offer?.purchase_order_line_items?[0]

      listingDates: ->
        return '' unless @lineItem?.available_dates?.length
        dates = @lineItem.available_dates.sort((a, b) => new Date(a.starts_on) - new Date(b.starts_on))
        startDate = dates[0]?.starts_on
        endDate = dates[dates.length - 1]?.starts_on
        @$options.filters.formatDateWindow startDate, endDate

      isProductSampling: ->
        return @offer.activation_snapshot_space_names[0].startsWith 'product_sampling:'

      isOnsite: ->
        return @offer.activation_snapshot_space_names[0].startsWith 'onsite_'

      isOmnichannel: ->
        return @offer.activation_snapshot_space_names[0].startsWith 'omnichannel'

      spaceSize: ->
        return unless @isOnsite
        # split and get only the space size
        # (e.g "onsite_space-10x10:Onsite Name" will give "10x10" for space size)
        @offer.activation_snapshot_space_names[0].split(':')?[0]?.split('-')?[1]

      offerStatusBorderClass: ->
        switch @offer.state
          when 'pending', 'submitted' then 'border-draft'
          when 'accepted' then 'border-success'
          when 'denied' then 'border-red'
          else 'border-divider'
      offerStatusTagClass: ->
        switch @offer.state
          when 'pending', 'submitted' then 'bg-draft'
          when 'accepted' then 'bg-success'
          when 'denied' then 'bg-red'
          else 'bg-recess'

      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]
      brandInfo: -> @activation?.brand_info || {}
      brandName: -> @brandInfo.name || @ctxSponsorOrg(@offer).name

      hasBoothActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['booth']
        has
      hasFoodTruckActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['foodtruck', 'food_truck', 'food truck']
        has
      hasTrailerActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['truck', 'trailer']
        has
      hasSamplingActivation: ->
        has = false
        space = (@offer?.activation_snapshot_space_names || []).join(" ").toLowerCase()
        (has ||= -1 < space.indexOf type) for type in ['sampl']
        has
      dayExpiresAt: -> dayjs(@offer.expires_at).add(1, 'day')
      isExpired: ->  not @dayExpiresAt.isAfter(dayjs())

      brandInfoCategories: ->
        categories = []
        Object.values(@offer.activation_snapshots).forEach((snapshot) ->
          categories = [...categories, ...snapshot.brand_info.category_tags]
        )
        categories

      hasShippingArea: ->
        @isProductSampling and !!@ctxShippingArea(@offer).id

      showShippingInfo: ->
        @isProductSampling && @offer.state is 'accepted' && (@currentMemberIsSupplier() || @currentMemberIsSuperUser())

      earliestShippingDate: ->
        starts = @activationPlan.start_date
        earliest = @shippingArea.delivery_window?.earliest || 3
        dayjs(starts).subtract(earliest, 'days').format('MMM DD')
      latestShippingDate: ->
        starts = @activationPlan.start_date
        latest = @shippingArea.delivery_window?.latest || 1
        dayjs(starts).subtract(latest, 'days').format('MMM DD')

    methods:
      hiShipAddressToClipboard: (event) ->
        @copyToClipboard event, @shippingArea.address
        @showFlash { 'Message:': 'Copied to clipboard' }

export default VueOptions.vue settings
